import React, { useState, useEffect, useCallback, useRef } from 'react';
import { initializeApp } from 'firebase/app';
import './App.css';
import { deleteDoc, writeBatch} from "firebase/firestore";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';


import { getAuth, signInAnonymously } from 'firebase/auth';
import { 
    getFirestore, 
    doc, 
    setDoc, 
    getDoc, 
    collection, 
    addDoc, 
    query, 
    where, 
    onSnapshot,
    updateDoc,
    getDocs
} from 'firebase/firestore';

// --- Firebase 설정 및 경로 ---
const firebaseConfig = {
  apiKey: "AIzaSyCNRLbTitzVqSywdOAu5PrTWILfiMhVHTo",  // ← 본인의 값으로 교체
  authDomain: "my-app-e7360.firebaseapp.com",
  projectId: "my-app-e7360",
  storageBucket: "my-app-e7360.appspot.com",
  messagingSenderId: "123456789012",
  appId: "1:123456789012:web:abc123def4567890abcd12",
  measurementId: "G-ABCDE12345"
};

export const appId = "my-app-e7360";



const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const getCollectionPath = (collectionName) => `artifacts/${appId}/public/data/${collectionName}`;
const getDocPath = (collectionName, docId) => `artifacts/${appId}/public/data/${collectionName}/${docId}`;

// --- 아이콘 컴포넌트 ---
const SparklesIcon = ({ className }) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}><path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456Z" /></svg>;
const ClipboardIcon = ({ className }) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}><path strokeLinecap="round" strokeLinejoin="round" d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a2.25 2.25 0 0 1-2.25 2.25h-1.5a2.25 2.25 0 0 1-2.25-2.25v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184" /></svg>;
const UsersIcon = ({ className }) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}><path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m-7.5-2.966c-1.41-1.41-1.41-3.684 0-5.094l.286-.286c.79-.79 2.074-.79 2.864 0l.286.286c.79.79.79 2.074 0 2.864m-3.15 3.15.286-.286c.79-.79 2.074-.79 2.864 0l.286.286c.79.79.79 2.074 0 2.864m-4.95-4.95c.79-.79 2.074-.79 2.864 0l.286.286c.79.79.79 2.074 0 2.864l-.286.286c-.79.79-2.074.79-2.864 0m12.012 5.094c.79-.79.79-2.074 0-2.864l-.286-.286c-.79-.79-2.074-.79-2.864 0l-.286.286c-.79.79-.79 2.074 0 2.864l.286.286c.79.79 2.074.79 2.864 0ZM12 6.375h.008v.008H12V6.375Z" /></svg>;
const CampaignIcon = ({ className }) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}><path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6a7.5 7.5 0 1 0 7.5 7.5h-7.5V6Z" /><path strokeLinecap="round" strokeLinejoin="round" d="M13.5 10.5H21A7.5 7.5 0 0 0 13.5 3v7.5Z" /></svg>;
const SearchIcon = ({ className }) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}><path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" /></svg>;


// --- 화면 컴포넌트 ---
const AuthScreen = ({ onAdminLogin, onUserLogin, loginError }) => {
    const [authMode, setAuthMode] = useState('user');
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('influencer');
    const [adminId, setAdminId] = useState('');
    const [adminPassword, setAdminPassword] = useState('');
    const [error, setError] = useState('');

    useEffect(() => { setError(loginError); }, [loginError]);

    const handleUserAuth = (e) => { e.preventDefault(); setError(''); if (!email) { setError('이메일을 입력해주세요.'); return; } onUserLogin(email, role); };
    const handleAdminLogin = (e) => { e.preventDefault(); setError(''); if (adminId === 'admin' && adminPassword === '123456') { onAdminLogin(); } else { setError('관리자 아이디 또는 비밀번호가 잘못되었습니다.'); } };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-900 text-white login">
            <div className="w-full max-w-md p-8 space-y-6 bg-gray-800 rounded-lg shadow-lg">
                <div className="flex border-b border-gray-700">
                    <button onClick={() => { setAuthMode('user'); setError(''); }} className={`flex-1 py-2 font-semibold ${authMode === 'user' ? 'text-indigo-400 border-b-2 border-indigo-400' : 'text-gray-500'}`}>일반 사용자</button>
                    <button onClick={() => { setAuthMode('admin'); setError(''); }} className={`flex-1 py-2 font-semibold ${authMode === 'admin' ? 'text-indigo-400 border-b-2 border-indigo-400' : 'text-gray-500'}`}>관리자</button>
                </div>
                {authMode === 'user' && (
                    <div className='login'>
                        <h2 className="text-2xl font-bold text-center text-white mb-4">이메일로 시작하기</h2>
                        <p className="text-center text-gray-400 mb-6 text-sm">이메일을 입력하여 로그인 또는 회원가입하세요.<br/>처음인 경우, 아래에서 역할을 선택해주세요.</p>
                        <form className="space-y-4" onSubmit={handleUserAuth}>
                            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="이메일" required className="w-full input-style" />
                            <div className="pt-2">
                               <p className="text-sm text-gray-300 mb-2">가입 유형 선택 (처음인 경우)</p>
                                <div className="flex justify-around p-2 bg-gray-700 rounded-lg">
                                    <label className="flex items-center space-x-2 cursor-pointer"><input type="radio" name="role" value="influencer" checked={role === 'influencer'} onChange={() => setRole('influencer')} className="form-radio text-indigo-400" /><span>인플루언서</span></label>
                                    <label className="flex items-center space-x-2 cursor-pointer"><input type="radio" name="role" value="merchant" checked={role === 'merchant'} onChange={() => setRole('merchant')} className="form-radio text-indigo-400" /><span>Merchant</span></label>
                                </div>
                            </div>
                            <button type="submit" className="w-full py-2 font-bold text-white bg-indigo-600 rounded-md hover:bg-indigo-700">이메일로 시작하기</button>
                        </form>
                    </div>
                )}
                {authMode === 'admin' && (
                     <div className='login'>
                        <h2 className="text-2xl font-bold text-center text-white mb-4">관리자 로그인</h2>
                        <form className="space-y-4" onSubmit={handleAdminLogin}>
                            <input type="text" value={adminId} onChange={e => setAdminId(e.target.value)} placeholder="관리자 ID" required className="w-full input-style" />
                            <input type="password" value={adminPassword} onChange={e => setAdminPassword(e.target.value)} placeholder="비밀번호" required className="w-full input-style" />
                            <button type="submit" className="w-full py-2 font-bold text-white bg-red-600 rounded-md hover:bg-red-700">관리자 로그인</button>
                        </form>
                    </div>
                )}
                 {error && <p className="text-sm text-center text-red-400 mt-4">{error}</p>}
            </div>
        </div>
    );
};

const UserDetailModal = ({ user, onClose }) => {
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!user) return;
        const fetchDetails = async () => {
            setLoading(true);
            const collectionName = user.role === 'influencer' ? 'influencers' : 'merchants';
            const docRef = doc(db, getDocPath(collectionName, user.id));
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                setDetails(docSnap.data());
            }
            setLoading(false);
        };
        fetchDetails();
    }, [user]);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50" onClick={onClose}>
            <div className="bg-gray-800 rounded-lg p-8 w-full max-w-lg space-y-4" onClick={e => e.stopPropagation()}>
                <h3 className="text-xl font-bold text-indigo-400">사용자 상세 정보</h3>
                {loading ? <p>로딩 중...</p> : details ? (
                    <div className="space-y-3 text-gray-300">
                        <p><strong>이메일:</strong> {user.email}</p>
                        <p><strong>역할:</strong> {user.role}</p>
                        <p><strong>상태:</strong> {user.status}</p>
                        <p><strong>가입일:</strong> {new Date(user.createdAt?.seconds * 1000).toLocaleString()}</p>
                        <hr className="border-gray-600"/>
                        <h4 className="font-semibold text-lg text-indigo-300">프로필 정보</h4>
                        {Object.entries(details).map(([key, value]) => {
                             if (key === 'profileImageUrl' && value) {
                                 return <div key={key}><strong className="capitalize">{key}:</strong><br/><img src={value} alt="Profile" className="mt-2 w-32 h-32 rounded-lg object-cover"/></div>
                             }
                             if (key === 'socialMedia' && Array.isArray(value)) {
                                 return <div key={key}><strong className="capitalize">{key}:</strong><ul className="list-disc list-inside ml-4">{value.map((item, i) => <li key={i}>{item.platform}: <a href={item.url} target="_blank" rel="noopener noreferrer" className="text-indigo-400 hover:underline">{item.url}</a></li>)}</ul></div>
                             }
                            return <p key={key}><strong>{key}:</strong> {String(value)}</p>
                        })}
                    </div>
                ) : <p>프로필 정보를 찾을 수 없습니다.</p>}
                <button onClick={onClose} className="mt-4 w-full px-4 py-2 bg-gray-600 hover:bg-gray-700 rounded-md">닫기</button>
            </div>
        </div>
    );
};

// --- 대시보드 및 기타 컴포넌트 ---
const AdminDashboard = () => {
    const [users, setUsers] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const [detailUser, setDetailUser] = useState(null);

    const influencers = users.filter(u => u.role === 'influencer');
    const merchants = users.filter(u => u.role === 'merchant');

    useEffect(() => {
        const unsubUsers = onSnapshot(collection(db, getCollectionPath("users")), (snapshot) => setUsers(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))));
        const unsubCampaigns = onSnapshot(collection(db, getCollectionPath("campaigns")), (snapshot) => setCampaigns(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))));
        return () => { unsubUsers(); unsubCampaigns(); };
    }, []);

    const toggleUserStatus = async (userId, currentStatus) => await updateDoc(doc(db, getDocPath("users", userId)), { status: currentStatus === 'active' ? 'suspended' : 'active' });
    const toggleCampaignStatus = async (campaignId, currentStatus) => await updateDoc(doc(db, getDocPath("campaigns", campaignId)), { status: currentStatus === 'active' ? 'suspended' : 'active' });

    const stats = { users: users.length, merchants: merchants.length, influencers: influencers.length, campaigns: campaigns.length };

    const UserTable = ({ title, userList }) => (
        <div className="bg-gray-800 p-6 rounded-lg scroll">
            <h2 className="text-xl font-semibold mb-4">{title} ({userList.length})</h2>
            <div className="overflow-auto max-h-96">
                <table className="w-full text-left">
                    <thead><tr className="border-b border-gray-700"><th className="p-2">이메일</th><th className="p-2">상태</th><th className="p-2">작업</th></tr></thead>
                    <tbody>{userList.map(u => <tr key={u.id} className="border-t border-gray-700">
                        <td className="p-2">{u.email}</td>
                        <td className="p-2"><span className={`px-2 py-1 text-xs font-semibold rounded-full ${u.status === 'active' ? 'bg-green-500 text-green-900' : 'bg-red-500 text-red-900'}`}>{u.status}</span></td>
                        <td className="p-2 space-x-2 btn-wrap">
                            <button onClick={() => toggleUserStatus(u.id, u.status)} className="px-3 py-1 bg-gray-600 hover:bg-gray-700 rounded text-sm">상태변경</button>
                            <button onClick={() => setDetailUser(u)} className="px-3 py-1 bg-indigo-600 hover:bg-indigo-700 rounded text-sm">상세보기</button>
                        </td>
                    </tr>)}</tbody>
                </table>
            </div>
        </div>
    );

    return (
        <div className="p-8">
            <h1 className="text-3xl font-bold mb-6 text-indigo-400">관리자 대시보드</h1>
            <div className="flex-dashboard">
                <div className="bg-gray-800 p-6 rounded-lg flex items-center gap-4"><UsersIcon className="w-10 h-10 text-indigo-400" /><div><div className="text-3xl font-bold">{stats.users}</div><div className="text-gray-400">총 사용자</div></div></div>
                <div className="bg-gray-800 p-6 rounded-lg flex items-center gap-4"><UsersIcon className="w-10 h-10 text-teal-400" /><div><div className="text-3xl font-bold">{stats.merchants}</div><div className="text-gray-400">Merchants</div></div></div>
                <div className="bg-gray-800 p-6 rounded-lg flex items-center gap-4"><UsersIcon className="w-10 h-10 text-sky-400" /><div><div className="text-3xl font-bold">{stats.influencers}</div><div className="text-gray-400">인플루언서</div></div></div>
                <div className="bg-gray-800 p-6 rounded-lg flex items-center gap-4"><CampaignIcon className="w-10 h-10 text-rose-400" /><div><div className="text-3xl font-bold">{stats.campaigns}</div><div className="text-gray-400">총 캠페인</div></div></div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <UserTable title="인플루언서 목록" userList={influencers} />
                <UserTable title="Merchant 목록" userList={merchants} />
                <div className="bg-gray-800 p-6 rounded-lg  scroll lg:col-span-2"><h2 className="text-xl font-semibold mb-4">캠페인 관리</h2><div className="overflow-auto max-h-96">
                    <table className="w-full text-left">
                        <thead><tr className="border-b border-gray-700"><th className="p-2">캠페인명</th><th className="p-2">상태</th><th className="p-2">작업</th></tr></thead>
                        <tbody>{campaigns.map(c => <tr key={c.id} className="border-t border-gray-700">
                            <td className="p-2">{c.title}</td>
                            <td className="p-2"><span className={`px-2 py-1 text-xs font-semibold rounded-full ${c.status === 'active' ? 'bg-green-500 text-green-900' : 'bg-red-500 text-red-900'}`}>{c.status}</span></td>
                            <td className="p-2"><button onClick={() => toggleCampaignStatus(c.id, c.status)} className="px-3 py-1 bg-gray-600 hover:bg-gray-700 rounded text-sm">변경</button></td>
                        </tr>)}</tbody>
                    </table>
                </div></div>
            </div>
            {detailUser && <UserDetailModal user={detailUser} onClose={() => setDetailUser(null)} />}
        </div>
    );
};
const CampaignModal = ({ campaign, onClose, onSave }) => {
    const [campaignData, setCampaignData] = useState(campaign);

    useEffect(() => {
        setCampaignData(campaign);
    }, [campaign]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCampaignData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = () => {
        onSave(campaignData);
        onClose();
    };

    if (!campaign) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
            <div className="bg-gray-800 rounded-lg p-8 w-full max-w-lg space-y-4">
                <h3 className="text-xl font-bold text-indigo-400">캠페인 수정</h3>
                <div><strong className="text-gray-400">제목:</strong><input type="text" name="title" value={campaignData.title} onChange={handleChange} className="w-full mt-1 input-style" /></div>
                <div><strong className="text-gray-400">설명:</strong><textarea name="description" value={campaignData.description} onChange={handleChange} rows="4" className="w-full mt-1 input-style"></textarea></div>
                <div><strong className="text-gray-400">보상:</strong><input type="text" name="reward" value={campaignData.reward} onChange={handleChange} className="w-full mt-1 input-style" /></div>
                <div className="flex justify-end gap-4 mt-4">
                    <button onClick={onClose} className="px-4 py-2 bg-gray-600 hover:bg-gray-700 rounded-md">취소</button>
                    <button onClick={handleSave} className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 rounded-md">저장</button>
                </div>
            </div>
        </div>
    );
};

const MerchantProfileForm = ({ user }) => {
    const [profile, setProfile] = useState({ companyName: '', description: '', website: '' });
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (user?.uid) {
            const docRef = doc(db, getDocPath("merchants", user.uid));
            const unsub = onSnapshot(docRef, (docSnap) => {
                if (docSnap.exists()) {
                    setProfile(docSnap.data());
                }
            });
            return () => unsub();
        }
    }, [user]);

    const handleChange = (e) => setProfile({ ...profile, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        await setDoc(doc(db, getDocPath("merchants", user.uid)), profile, { merge: true });
        setMessage('프로필이 성공적으로 업데이트되었습니다.');
        setTimeout(() => setMessage(''), 3000);
    };

    return (
        <div className="bg-gray-800 p-6 rounded-lg margin">
            <h2 className="text-xl font-semibold mb-4">프로필 관리</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <input type="text" name="companyName" placeholder="회사명" value={profile.companyName || ''} onChange={handleChange} className="w-full input-style" />
                <textarea name="description" placeholder="소개" value={profile.description || ''} onChange={handleChange} rows="4" className="w-full input-style"></textarea>
                <input type="url" name="website" placeholder="웹사이트 URL" value={profile.website || ''} onChange={handleChange} className="w-full input-style" />
                <button type="submit" className="w-full py-2 px-4 bg-indigo-600 hover:bg-indigo-700 rounded-md font-bold transition">프로필 저장</button>
                {message && <p className="text-center text-green-400 mt-2">{message}</p>}
            </form>
        </div>
    );
};

const MerchantDashboard = ({ user }) => {
    const [currentTab, setCurrentTab] = useState('campaigns');
    const [campaigns, setCampaigns] = useState([]);
    const [applications, setApplications] = useState([]);
    const [newCampaign, setNewCampaign] = useState({ title: '', description: '', reward: '' });
    const [editingCampaign, setEditingCampaign] = useState(null);

    useEffect(() => {
        if (!user?.uid) return;
        const q = query(collection(db, getCollectionPath("campaigns")), where("merchantId", "==", user.uid));
        const unsubCampaigns = onSnapshot(q, (snapshot) => {
            setCampaigns(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });
        return () => unsubCampaigns();
    }, [user]);

    useEffect(() => {
        if (campaigns.length === 0) {
            setApplications([]);
            return;
        }
        const campaignIds = campaigns.map(c => c.id);
        const appsQuery = query(collection(db, getCollectionPath("applications")), where("campaignId", "in", campaignIds));
        const unsubApps = onSnapshot(appsQuery, async (appsSnapshot) => {
            const appsData = await Promise.all(appsSnapshot.docs.map(async (docSnapshot) => {
                const app = { id: docSnapshot.id, ...docSnapshot.data() };
                const influencerUserDoc = await getDoc(doc(db, getDocPath("users", app.influencerId)));
                const campaign = campaigns.find(c => c.id === app.campaignId);
                return { 
                    ...app, 
                    influencerEmail: influencerUserDoc.exists() ? influencerUserDoc.data().email : 'N/A', 
                    campaignTitle: campaign ? campaign.title : '삭제된 캠페인' 
                };
            }));
            setApplications(appsData);
        });
        return () => unsubApps();
    }, [campaigns]);

    const handleCreateCampaign = async (e) => {
        e.preventDefault();
        if (!newCampaign.title || !newCampaign.description || !newCampaign.reward) return;
        // 마침표 뒤에 공백 추가
        const formattedDescription = newCampaign.description.replace(/\.(?!\s)/g, ". ");
        await addDoc(collection(db, getCollectionPath("campaigns")), { ...newCampaign, description: formattedDescription, merchantId: user.uid, status: 'active', createdAt: new Date() });
        setNewCampaign({ title: '', description: '', reward: '' });
    };

    const handleApplication = async (appId, status) => await updateDoc(doc(db, getDocPath("applications", appId)), { status });

    const handleSaveCampaign = async (campaignData) => {
        const campaignRef = doc(db, getDocPath("campaigns", campaignData.id));
        await updateDoc(campaignRef, campaignData);
        setEditingCampaign(null);
    };

    const handleDeleteCampaign = async (campaignId) => {
        if (window.confirm("이 캠페인을 정말 삭제하시겠습니까? 관련 신청 데이터도 함께 삭제됩니다.")) {
            try {
                await deleteDoc(doc(db, getDocPath("campaigns", campaignId)));
                const q = query(collection(db, getCollectionPath("applications")), where("campaignId", "==", campaignId));
                const querySnapshot = await getDocs(q);
                const batch = writeBatch(db);
                querySnapshot.forEach(doc => batch.delete(doc.ref));
                await batch.commit();
                alert("캠페인이 삭제되었습니다.");
            } catch (error) {
                console.error("캠페인 삭제 오류: ", error);
                alert("캠페인 삭제 중 오류가 발생했습니다.");
            }
        }
    };

    return (
        <div className="p-8 merchant">
            <h1 className="text-3xl font-bold mb-6 text-indigo-400">Merchant 대시보드</h1>
            <div className="mb-6 border-b border-gray-700">
                <nav className="flex space-x-4">
                    <button onClick={() => setCurrentTab('campaigns')} className={`py-2 px-4 font-semibold ${currentTab === 'campaigns' ? 'text-indigo-400 border-b-2 border-indigo-400' : 'text-gray-400'}`}>캠페인 관리</button>
                    <button onClick={() => setCurrentTab('profile')} className={`py-2 px-4 font-semibold ${currentTab === 'profile' ? 'text-indigo-400 border-b-2 border-indigo-400' : 'text-gray-400'}`}>프로필 관리</button>
                </nav>
            </div>
            {currentTab === 'campaigns' && (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                     <div className="bg-gray-800 p-6 rounded-lg">
                        <h2 className="text-xl font-semibold">새 캠페인 생성</h2>
                        <form onSubmit={handleCreateCampaign} className="space-y-4 mt-4">
                            <input type="text" placeholder="캠페인 제목" value={newCampaign.title} onChange={e => setNewCampaign({...newCampaign, title: e.target.value})} className="w-full input-style"/>
                            <textarea placeholder="캠페인 설명" value={newCampaign.description} onChange={e => setNewCampaign({...newCampaign, description: e.target.value})} rows="4" className="w-full input-style"></textarea>
                            <input type="text" placeholder="보상 (e.g., 50,000원)" value={newCampaign.reward} onChange={e => setNewCampaign({...newCampaign, reward: e.target.value})} className="w-full input-style"/>
                            <button type="submit" className="w-full py-2 px-4 bg-indigo-600 hover:bg-indigo-700 rounded-md font-bold transition">생성하기</button>
                        </form>
                    </div>
                    <div className="bg-gray-800 p-6 rounded-lg">
                        <h2 className="text-xl font-semibold mb-4">내 캠페인 목록</h2>
                        <div className="space-y-3 max-h-96 overflow-y-auto pr-2">
                            {campaigns.length > 0 ? campaigns.map(c => (
                                <div key={c.id} className="p-3 bg-gray-700 rounded">
                                    <h3 className="font-bold">{c.title}</h3>
                                    <p className="text-sm text-gray-400 whitespace-pre-wrap">{c.description}</p>
                                    <p className="text-sm font-semibold text-green-400">보상: {c.reward}</p>
                                    <div className="flex justify-end gap-2 mt-2">
                                        <button onClick={() => setEditingCampaign(c)} className="flex items-center gap-1 px-2 py-1 text-xs bg-blue-600 rounded">수정</button>
                                        <button onClick={() => handleDeleteCampaign(c.id)} className="flex items-center gap-1 px-2 py-1 text-xs bg-red-600 rounded">삭제</button>
                                    </div>
                                </div>
                            )) : <p className="text-gray-500">생성된 캠페인이 없습니다.</p>}
                        </div>
                    </div>
                   <div className="bg-gray-800 p-6 rounded-lg lg:col-span-2">
                        <h2 className="text-xl font-semibold mb-4">신청 집계 관리</h2>
                        <div className="overflow-x-auto">
                            <table className="w-full text-left">
                            <thead><tr><th className="p-2">캠페인</th><th className="p-2">신청자</th><th className="p-2">상태</th><th className="p-2">작업</th></tr></thead>
                            <tbody>
                                {applications.length > 0 ? applications.map(app => (
                                <tr key={app.id} className="border-t border-gray-700">
                                    <td className="p-2">{app.campaignTitle}</td>
                                    <td className="p-2">{app.influencerEmail}</td>
                                    <td className="p-2">
                                    <span className={`px-2 py-1 text-xs font-semibold rounded-full ${app.status === 'approved' ? 'bg-green-500 text-green-900' : app.status === 'rejected' ? 'bg-red-500 text-red-900' : 'bg-yellow-500 text-yellow-900'}`}>{app.status === 'approved' ? '승인됨' : app.status === 'rejected' ? '거절됨' : '대기중'}</span>
                                    </td>
                                    <td className="p-2 space-x-2">{app.status === 'pending' && (
                                        <>
                                        <button onClick={() => handleApplication(app.id, 'approved')} className="px-3 py-1 bg-green-600 hover:bg-green-700 rounded text-sm">승인</button>
                                        <button onClick={() => handleApplication(app.id, 'rejected')} className="px-3 py-1 bg-red-600 hover:bg-red-700 rounded text-sm">거절</button>
                                        </>
                                    )}</td>
                                </tr>
                                )) : <tr><td colSpan="4" className="text-center p-4 text-gray-500">신청 내역이 없습니다.</td></tr>}
                            </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
            {currentTab === 'profile' && <MerchantProfileForm user={user} />}
            {editingCampaign && <CampaignModal campaign={editingCampaign} onClose={() => setEditingCampaign(null)} onSave={handleSaveCampaign} />}
        </div>
    );
};
const InfluencerProfileForm = ({ user }) => {
    const [profile, setProfile] = useState({ name: '', bio: '', followers: '', niche: '', phone: '', profileImageUrl: '', socialMedia: [] });
    const [social, setSocial] = useState({ platform: 'Instagram', url: '' });
    const [message, setMessage] = useState('');
    const fileInputRef = useRef(null);

    useEffect(() => {
        if (!user?.uid) return;
        const fetchProfile = async () => {
            const docRef = doc(db, getDocPath("influencers", user.uid));
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) { setProfile(docSnap.data()); }
        };
        fetchProfile();
    }, [user]);

    const handleProfileChange = (e) => setProfile({ ...profile, [e.target.name]: e.target.value });
    const handleSocialChange = (e) => setSocial({ ...social, [e.target.name]: e.target.value });
    
    const addSocialMedia = () => {
        if (!social.url || !social.platform) return;
        setProfile({ ...profile, socialMedia: [...(profile.socialMedia || []), social] });
        setSocial({ platform: 'Instagram', url: '' });
    };

    const removeSocialMedia = (index) => {
        const newSocialMedia = [...profile.socialMedia];
        newSocialMedia.splice(index, 1);
        setProfile({ ...profile, socialMedia: newSocialMedia });
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => { setProfile({ ...profile, profileImageUrl: reader.result }); };
        reader.readAsDataURL(file);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await setDoc(doc(db, getDocPath("influencers", user.uid)), profile, { merge: true });
            setMessage('프로필이 성공적으로 업데이트되었습니다.');
        } catch (error) { setMessage('오류가 발생했습니다: ' + error.message); }
        setTimeout(() => setMessage(''), 3000);
    };

    return (
        <div className="bg-gray-800 p-6 rounded-lg profile1">
            <h2 className="text-xl font-semibold mb-4">프로필 관리</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="flex items-center gap-4">
                     <img src={profile.profileImageUrl} alt="Profile Preview" className="w-24 h-24 rounded-full object-cover bg-gray-700" onError={(e) => { e.target.onerror = null; e.target.src=`https://placehold.co/200/4f46e5/ffffff?text=IMG`}}/>
                     <div className='profile-box'>
                        <h3 className="font-semibold mb-1">프로필 이미지</h3>
                        <button type="button" onClick={() => fileInputRef.current.click()} className="px-3 py-1 text-sm bg-gray-600 hover:bg-gray-700 rounded">이미지 선택</button>
                        <input type="file" ref={fileInputRef} onChange={handleImageUpload} accept="image/*" className="hidden" />
                     </div>
                </div>
                <input type="text" name="name" placeholder="이름/활동명" value={profile.name || ''} onChange={handleProfileChange} className="w-full input-style" />
                <input type="tel" name="phone" placeholder="연락처 (예: 010-1234-5678)" value={profile.phone || ''} onChange={handleProfileChange} className="w-full input-style" />
                <textarea name="bio" placeholder="소개" value={profile.bio || ''} onChange={handleProfileChange} className="w-full input-style"></textarea>
                <input type="number" name="followers" placeholder="총 팔로워 수" value={profile.followers || ''} onChange={handleProfileChange} className="w-full input-style" />
                <input type="text" name="niche" placeholder="관심분야 (예: 뷰티, IT, 여행)" value={profile.niche || ''} onChange={handleProfileChange} className="w-full input-style" />
                <div className="space-y-2">
                    <h3 className="font-semibold">소셜 미디어 채널</h3>
                    {profile.socialMedia?.map((sm, index) => (
                        <div key={index} className="flex items-center gap-2">
                           <input type="text" value={`${sm.platform}: ${sm.url}`} readOnly className="w-full input-style bg-gray-600"/>
                           <button type="button" onClick={() => removeSocialMedia(index)} className="px-2 py-1 bg-red-600 text-white rounded text-xs">삭제</button>
                        </div>
                    ))}
                     <div className="flex items-center gap-2">
                        <select name="platform" value={social.platform} onChange={handleSocialChange} className="input-style bg-gray-200 text-black rounded p-2 border-none">
                            <option>Instagram</option><option>YouTube</option><option>TikTok</option><option>Blog</option><option>기타</option>
                        </select>
                        <input type="url" name="url" placeholder="채널 URL" value={social.url} onChange={handleSocialChange} className="w-full input-style" />
                        <button type="button" onClick={addSocialMedia} className="px-3 py-2 bg-green-600 text-white rounded whitespace-nowrap">추가</button>
                    </div>
                </div>
                <button type="submit" className="w-full py-2 px-4 bg-indigo-600 hover:bg-indigo-700 rounded-md font-bold transition">프로필 저장</button>
                {message && <p className="text-center text-green-400 mt-2">{message}</p>}
            </form>
        </div>
    );
};

const InfluencerDashboard = ({ user }) => {
    const [currentTab, setCurrentTab] = useState('campaigns');
    const [campaigns, setCampaigns] = useState([]);
    const [myApplications, setMyApplications] = useState([]);
    const [myProfile, setMyProfile] = useState(null);
    const [statusMessage, setStatusMessage] = useState({ text: '', type: '' });
    const [aiContentModal, setAiContentModal] = useState({ isOpen: false, isLoading: false, content: '', error: '', campaign: null });
    const [aiRecModal, setAiRecModal] = useState({ isOpen: false, isLoading: false, recommendations: [], error: '' });

    const showStatusMessage = (text, type) => { setStatusMessage({ text, type }); setTimeout(() => setStatusMessage({ text: '', type: '' }), 3000); };
    
    // useEffect(() => {
    //     if (!user?.uid) return;
    //     const unsubProfile = onSnapshot(doc(db, getDocPath("influencers", user.uid)), (docSnap) => { if (docSnap.exists()) setMyProfile(docSnap.data()); });
    //     const unsubCampaigns = onSnapshot(query(collection(db, getCollectionPath("campaigns")), where("status", "==", "active")), (snapshot) => setCampaigns(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))));
    //     const unsubMyApps = onSnapshot(query(collection(db, getCollectionPath("applications")), where("influencerId", "==", user.uid)), async (snapshot) => {
    //         const appsData = await Promise.all(snapshot.docs.map(async (doc) => { const app = { id: doc.id, ...doc.data() }; const campaignDoc = await getDoc(getDocPath("campaigns", app.campaignId)); return { ...app, campaign: campaignDoc.exists() ? {id: campaignDoc.id, ...campaignDoc.data()} : null }; }));
    //         setMyApplications(appsData.filter(app => app.campaign));
    //     });
    //     return () => { unsubProfile(); unsubCampaigns(); unsubMyApps(); }; 
    // }, [user]);
    useEffect(() => {
        if (!user?.uid) return;

        // 1. 프로필 실시간 구독
        const unsubProfile = onSnapshot(
            doc(db, getDocPath("influencers", user.uid)),
            (docSnap) => {
                if (docSnap.exists()) {
                    setMyProfile(docSnap.data());
                }
            },
            (error) => {
                console.error("Error fetching influencer profile:", error);
            }
        );

        // 2. 활성 캠페인 목록 실시간 구독
        const unsubCampaigns = onSnapshot(
            query(
                collection(db, getCollectionPath("campaigns")),
                where("status", "==", "active")
            ),
            (snapshot) => {
                const campaignsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setCampaigns(campaignsData);
            },
            (error) => {
                console.error("Error fetching campaigns:", error);
            }
        );

        // 3. 내가 신청한 캠페인 목록 실시간 구독 (수정된 부분)
        const unsubMyApps = onSnapshot(
            query(
                collection(db, getCollectionPath("applications")),
                where("influencerId", "==", user.uid)
            ),
            async (snapshot) => {
                const appsData = await Promise.all(snapshot.docs.map(async (appDoc) => {
                    const app = { id: appDoc.id, ...appDoc.data() };
                    try {
                        if (app.campaignId) {
                            const campaignDocRef = doc(db, getDocPath("campaigns", app.campaignId));
                            const campaignDoc = await getDoc(campaignDocRef);
                            if (campaignDoc.exists()) {
                                app.campaign = { id: campaignDoc.id, ...campaignDoc.data() };
                            } else {
                                app.campaign = null; // 캠페인이 삭제된 경우
                            }
                        }
                        return app;
                    } catch (error) {
                        console.error("Error fetching campaign for application:", error);
                        return { ...app, campaign: null }; // 에러 발생 시
                    }
                }));
                
                // 캠페인 정보가 있는 신청만 필터링하여 상태 업데이트
                setMyApplications(appsData.filter(app => app && app.campaign));
            },
            (error) => {
                console.error("Error fetching applications:", error);
            }
        );

        // cleanup (언마운트 시 리스너 해제)
        return () => {
            unsubProfile();
            unsubCampaigns();
            unsubMyApps();
        };
    }, [user]);


    const handleApply = async (campaignId) => {
        if (myApplications.some(app => app.campaignId === campaignId)) { showStatusMessage("이미 신청한 캠페인입니다.", "error"); return; }
        await addDoc(collection(db, getCollectionPath("applications")), { campaignId, influencerId: user.uid, status: 'pending', appliedAt: new Date() });
        showStatusMessage("신청이 완료되었습니다.", "success");
    };
    
    const handleGenerateContent = async (campaign) => {
        setAiContentModal({ isOpen: true, isLoading: true, content: '', error: '', campaign });
        const prompt = `당신은 인기 소셜 미디어 인플루언서입니다. 다음 캠페인을 위한 매력적이고 설득력 있는 홍보 게시글 초안을 한국어로 작성해주세요. 독자들이 참여하고 싶게 만들어주세요. 관련 해시태그를 3~5개 포함해주세요.\n\n- 캠페인 제목: ${campaign.title}\n- 캠페인 설명: ${campaign.description}`;
        try {
            const payload = { contents: [{ role: "user", parts: [{ text: prompt }] }] }; const apiKey = ""; const apiUrl = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=${apiKey}`;
            const response = await fetch(apiUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
            if (!response.ok) throw new Error(`API 요청 실패: ${response.statusText}`);
            const result = await response.json();
            setAiContentModal(prev => ({ ...prev, isLoading: false, content: result.candidates[0].content.parts[0].text }));
        } catch (error) { console.error("Gemini API Error:", error); setAiContentModal(prev => ({ ...prev, isLoading: false, error: '콘텐츠 생성 중 오류가 발생했습니다.' })); }
    };

    const handleGetAiRecommendations = async () => {
        if (!myProfile || campaigns.length === 0) { showStatusMessage("프로필 정보와 캠페인 목록이 필요합니다.", "error"); return; }
        setAiRecModal({ isOpen: true, isLoading: true, recommendations: [], error: '' });

        const campaignInfo = campaigns.map(({id, title, description}) => ({id, title, description}));
        const prompt = `다음은 인플루언서 프로필과 참여 가능한 캠페인 목록입니다. 이 인플루언서에게 가장 적합한 캠페인을 최대 3개까지 추천하고, 그 이유를 설명해주세요. [인플루언서 프로필] ${JSON.stringify(myProfile)} [캠페인 목록] ${JSON.stringify(campaignInfo)} 응답은 반드시 다음 JSON 형식이어야 합니다: {"recommendations": [{"campaignId": "추천 캠페인 ID", "reason": "추천 이유"}]}`;

        try {
            const payload = { contents: [{ role: "user", parts: [{ text: prompt }] }], generationConfig: { responseMimeType: "application/json", responseSchema: { type: "OBJECT", properties: { recommendations: { type: "ARRAY", items: { type: "OBJECT", properties: { campaignId: { type: "STRING" }, reason: { type: "STRING" }}}}}}}};
            const apiKey = ""; const apiUrl = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=${apiKey}`;
            const response = await fetch(apiUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
            if (!response.ok) throw new Error(`API 요청 실패: ${response.statusText}`);
            const result = await response.json();
            const parsedResult = JSON.parse(result.candidates[0].content.parts[0].text);
            const recommendations = parsedResult.recommendations.map(rec => ({ ...rec, ...campaigns.find(c => c.id === rec.campaignId) })).filter(rec => rec.id);
            setAiRecModal({ isOpen: true, isLoading: false, recommendations, error: '' });
        } catch (error) {
            console.error("AI Recommendation Error:", error);
            setAiRecModal({ isOpen: true, isLoading: false, recommendations: [], error: "AI 추천 생성 중 오류가 발생했습니다." });
        }
    };
    
    const copyToClipboard = (text) => {
        const textArea = document.createElement("textarea"); textArea.value = text; document.body.appendChild(textArea); textArea.select();
        try { document.execCommand('copy'); showStatusMessage("콘텐츠가 복사되었습니다!", "success"); } catch (err) { showStatusMessage("복사에 실패했습니다.", "error"); }
        document.body.removeChild(textArea);
    };

    const myAppliedCampaignIds = myApplications.map(app => app.campaignId);

    return (
       <div className={`p-8 influ ${currentTab === 'profile' ? 'profile-mode' : ''}`}>
            <h1 className="text-3xl font-bold mb-6 text-indigo-400">인플루언서 대시보드</h1>
            <div className="mb-6 border-b border-gray-700">
                <nav className="flex space-x-4">
                    <button onClick={() => setCurrentTab('campaigns')} className={`py-2 px-4 font-semibold ${currentTab === 'campaigns' ? 'text-indigo-400 border-b-2 border-indigo-400' : 'text-gray-400'}`}>캠페인</button>
                    <button onClick={() => setCurrentTab('profile')} className={`py-2 px-4 font-semibold ${currentTab === 'profile' ? 'text-indigo-400 border-b-2 border-indigo-400' : 'text-gray-400'}`}>프로필 관리</button>
                </nav>
            </div>
            {currentTab === 'campaigns' && (
                <div className="campaigns1">
                    <div className="bg-gray-800 p-6 rounded-lg scroll campaigns-left">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-xl font-semibold">참여 가능한 캠페인</h2>
                            <button onClick={handleGetAiRecommendations} className="hidden"><SparklesIcon className="w-5 h-5"/> AI 캠페인 추천</button>
                        </div>
                        <div className="space-y-4 max-h-[600px] overflow-y-auto pr-2">{campaigns.map(c => <div key={c.id} className="p-4 bg-gray-700 rounded-lg flex justify-between items-center"><div className='product'><h3 className="font-bold text-lg">{c.title}</h3><p className="text-sm text-gray-300 mt-1">{c.description}</p><p className="text-sm font-semibold text-green-400 mt-2">보상: {c.reward}</p></div><button onClick={() => handleApply(c.id)} disabled={myAppliedCampaignIds.includes(c.id)} className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 rounded-md font-bold transition disabled:bg-gray-500 disabled:cursor-not-allowed whitespace-nowrap"> {myAppliedCampaignIds.includes(c.id) ? '신청완료' : '신청하기'} </button></div>)}</div>
                    </div>
                 <div className="bg-gray-800 p-6 rounded-lg scroll campaigns-right">
  <h2 className="text-xl font-semibold mb-4">내 신청 현황</h2>
  <div className="space-y-4 max-h-[600px] overflow-y-auto pr-2">
    {myApplications.map(app => (
      <div key={app.id} className="p-4 bg-gray-700 rounded-lg">
        <div className="flex justify-between items-start">
          <div>
            <h3 className="font-bold text-lg">{app.campaign?.title}</h3>
            <p className="text-sm text-gray-300 mt-1">{app.campaign?.description}</p>
          </div>
          <span
            className={`text-xs font-semibold rounded-full whitespace-nowrap
              ${app.status === 'approved'
                ? 'bg-green-500 text-green-900 p-0'
                : app.status === 'rejected'
                  ? 'bg-red-500 text-red-900 p-0'
                  : 'bg-yellow-500 text-yellow-900 px-2 py-1'
              }`}
          >
            {app.status === 'pending' ? '대기중' : app.status === 'approved' ? '승인됨' : '거절됨'}
          </span>
        </div>

        {app.status === 'approved' && (
          <div className="mt-3 pt-3 border-t border-gray-600 space-y-2">
            <button onClick={() => handleGenerateContent(app.campaign)} className="hidden">
              <SparklesIcon className="w-5 h-5" />✨ AI로 콘텐츠 초안 작성
            </button>
          </div>
        )}
      </div>
    ))}
  </div>
</div>

                </div>
            )}
             {currentTab === 'profile' && <InfluencerProfileForm user={user} />}
            {statusMessage.text && (<div className={`fixed bottom-5 right-5 p-4 rounded-lg text-white shadow-lg transition-opacity duration-300 ${statusMessage.type === 'success' ? 'bg-green-600' : 'bg-red-600'}`}>{statusMessage.text}</div>)}
            {aiContentModal.isOpen && (<div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"><div className="bg-gray-800 rounded-lg p-8 w-full max-w-2xl max-h-[90vh] flex flex-col"><h3 className="text-xl font-bold text-indigo-400 mb-4">✨ AI 홍보 콘텐츠 초안</h3><div className="flex-grow bg-gray-900 rounded-md p-4 overflow-y-auto whitespace-pre-wrap text-gray-200">{aiContentModal.isLoading ? (<div className="flex items-center justify-center h-full"><p>콘텐츠를 생성 중입니다...</p></div>) : aiContentModal.error ? (<p className="text-red-400">{aiContentModal.error}</p>) : (aiContentModal.content)}</div><div className="flex justify-end gap-4 mt-4"><button onClick={() => setAiContentModal({ isOpen: false, isLoading: false, content: '', error: '', campaign: null })} className="px-4 py-2 bg-gray-600 hover:bg-gray-700 rounded-md">닫기</button><button onClick={() => copyToClipboard(aiContentModal.content)} disabled={aiContentModal.isLoading || !!aiContentModal.error} className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 rounded-md disabled:bg-indigo-900 flex items-center gap-2"><ClipboardIcon className="w-5 h-5"/>복사하기</button></div></div></div>)}
            {aiRecModal.isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50" onClick={() => setAiRecModal(p => ({...p, isOpen: false}))}>
                    <div className="bg-gray-800 rounded-lg p-8 w-full max-w-2xl max-h-[90vh] flex flex-col" onClick={e => e.stopPropagation()}>
                        <h3 className="text-xl font-bold text-indigo-400 mb-4">✨ AI 맞춤 캠페인 추천</h3>
                        <div className="flex-grow bg-gray-900 rounded-md p-4 overflow-y-auto space-y-4">
                            {aiRecModal.isLoading ? <p>AI가 맞춤 캠페인을 분석하고 있습니다...</p> : aiRecModal.error ? <p className="text-red-400">{aiRecModal.error}</p> :
                                aiRecModal.recommendations.length > 0 ? aiRecModal.recommendations.map(rec => (
                                    <div key={rec.id} className="p-4 bg-gray-700 rounded-lg">
                                        <h4 className="font-bold text-lg">{rec.title}</h4>
                                        <p className="text-sm text-green-400 mt-1">보상: {rec.reward}</p>
                                        <p className="mt-3 text-sm bg-gray-800 p-2 rounded"><strong>AI 추천 이유:</strong> {rec.reason}</p>
                                        <div className="text-right mt-2"><button onClick={() => { handleApply(rec.id); setAiRecModal(p => ({...p, isOpen: false})); }} disabled={myAppliedCampaignIds.includes(rec.id)} className="px-4 py-1 bg-indigo-600 hover:bg-indigo-700 rounded-md text-sm font-bold transition disabled:bg-gray-500"> {myAppliedCampaignIds.includes(rec.id) ? '신청완료' : '신청하기'} </button></div>
                                    </div>
                                )) : <p>추천할 캠페인을 찾지 못했습니다.</p>
                            }
                        </div>
                        <button onClick={() => setAiRecModal(p => ({...p, isOpen: false}))} className="mt-4 px-4 py-2 bg-gray-600 hover:bg-gray-700 rounded-md">닫기</button>
                    </div>
                </div>
            )}
        </div>
    );
};


// --- 메인 App 컴포넌트 ---
export default function App() {
    const [user, setUser] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);
    const [loginError, setLoginError] = useState('');

    useEffect(() => {
        // 페이지 로드 시 localStorage에서 세션 정보 확인
        try {
            const persistedUser = localStorage.getItem('userSession');
            if (persistedUser) {
                const session = JSON.parse(persistedUser);
                if (session.isAdmin) {
                    setIsAdmin(true);
                } else if (session.user && session.role) {
                    setUser(session.user);
                    setUserRole(session.role);
                }
            }
        } catch (error) {
            console.error("Failed to parse user session from localStorage", error);
            localStorage.removeItem('userSession');
        } finally {
            setLoading(false);
        }
    }, []);

    const handleUserLogin = async (email, role) => {
        setLoading(true); setLoginError('');
        try {
             await signInAnonymously(auth);
            const usersRef = collection(db, getCollectionPath("users"));
            const q = query(usersRef, where("email", "==", email));
            const querySnapshot = await getDocs(q);

            let userData, userId;

            if (!querySnapshot.empty) {
                const userDoc = querySnapshot.docs[0];
                userData = userDoc.data();
                userId = userDoc.id;
                if (userData.status === 'suspended') { 
                    setLoginError('이 계정은 정지되었습니다.'); 
                    setLoading(false); 
                    return; 
                }
            } else {
                // 이메일 기반으로 간단한 ID 생성
                const docId = email.replace(/[^a-zA-Z0-9]/g, '');
                const newUserDocRef = doc(db, getDocPath("users", docId));
                userData = { email: email, role: role, createdAt: new Date(), status: 'active' };
                await setDoc(newUserDocRef, userData);
                
                const profileCollectionName = role === 'merchant' ? 'merchants' : 'influencers';
                const profileData = role === 'merchant'
                    ? { companyName: "신규 회사", description: "서비스를 소개해 주세요.", website: "" }
                    : { name: email.split('@')[0], bio: "자신을 소개해 주세요.", followers: 0, niche: "미설정", phone: "" };
                await setDoc(doc(db, getDocPath(profileCollectionName, docId)), profileData);
                userId = docId;
            }
            
            const session = { user: { uid: userId, email }, role };
            localStorage.setItem('userSession', JSON.stringify(session)); // localStorage에 저장
            setUser(session.user);
            setUserRole(session.role);

        } catch (err) { 
            console.error("로그인/가입 오류:", err); 
            setLoginError('로그인 중 오류가 발생했습니다. 다시 시도해주세요.'); 
        } finally { 
            setLoading(false); 
        }
    };
    
    const handleLogout = () => { 
        localStorage.removeItem('userSession'); // localStorage에서 삭제
        setUser(null); 
        setUserRole(null); 
        setIsAdmin(false); 
    };

    const handleAdminLogin = () => { 
        localStorage.setItem('userSession', JSON.stringify({ isAdmin: true })); // localStorage에 저장
        setIsAdmin(true); 
    };

    // ... (renderContent 함수는 기존 코드와 동일하게 유지)
    const renderContent = () => {
        if (loading) return <div className="flex items-center justify-center h-screen bg-gray-900 text-white">연결 중...</div>;
        
        const loggedIn = user || isAdmin;
        const displayName = isAdmin ? '관리자' : user?.email;
        const displayRole = isAdmin ? 'Admin' : userRole === 'influencer' ? '인플루언서' : 'Merchant';

        if (loggedIn) {
             return (
                 <>
                    <nav className="bg-gray-800 shadow-md"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"><div className="flex items-center justify-between h-16"><div className="flex items-center logo"><div className="flex-shrink-0 text-white font-bold text-xl">AD Square</div></div><div className="flex info"><span className="mr-4 text-gray-300">{displayName} ({displayRole})</span><button onClick={handleLogout} className="px-3 py-2 rounded-md text-sm font-medium text-white bg-red-600 hover:bg-red-700">로그아웃</button></div></div></div></nav>
                    <main>
                        {isAdmin ? <AdminDashboard /> : userRole === 'merchant' ? <MerchantDashboard user={user} /> : <InfluencerDashboard user={user} />}
                    </main>
                </>
             );
        }
        
        return <AuthScreen onAdminLogin={handleAdminLogin} onUserLogin={handleUserLogin} loginError={loginError} />;
    }

    return (
        <div className="min-h-screen bg-gray-900 text-white font-sans">
            <style>{`.input-style { background-color: #E5E7EB; color: #111827; border-radius: 0.375rem; padding: 0.75rem; border: none; width: 100%; }`}</style>
            {renderContent()}
        </div>
    );
}
